
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-on-boarding"}},[_c('rect',{attrs:{"id":"Rectangle_14278","data-name":"Rectangle 14278","width":"20","height":"20","fill":"#fff"}})]),_c('clipPath',{attrs:{"id":"clip-path-on-boarding-2"}},[_c('rect',{attrs:{"id":"Rectangle_14277","data-name":"Rectangle 14277","width":"10.362","height":"5.674","fill":"none"}})])]),_c('g',{attrs:{"id":"Command_bar","data-name":"Command bar","clip-path":"url(#clip-path-on-boarding)"}},[_c('g',{attrs:{"id":"Group_43351","data-name":"Group 43351","transform":"translate(2 5)"}},[_c('rect',{attrs:{"id":"Rectangle_14276","data-name":"Rectangle 14276","width":"16","height":"10","rx":"1","fill":"#fff","stroke":"#5a677d","stroke-width":"1.5"}}),_c('g',{attrs:{"id":"Group_43350","data-name":"Group 43350","transform":"translate(3 2.163)"}},[_c('g',{attrs:{"id":"Group_43349","data-name":"Group 43349","clip-path":"url(#clip-path-on-boarding-2)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-width":"1.5"}},[_c('line',{attrs:{"id":"Line_1324","data-name":"Line 1324","y2":"4.174","transform":"translate(.75 .75)"}}),_c('line',{attrs:{"id":"Line_1325","data-name":"Line 1325","x1":"2.026","y1":"2.026","transform":"translate(7.586 .75)"}}),_c('line',{attrs:{"id":"Line_1326","data-name":"Line 1326","x1":"2.026","y2":"2.026","transform":"translate(7.586 2.898)"}})])])])])])
          )
        }
      }
    